import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import "./DrivingSchool.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BranchCard from "../../Components/BranchCard/BranchCard";
import IdCard from "../../assets/LearnersUIimages/IdCard.png";
import BirthdayCertificate from "../../assets/LearnersUIimages/BirthdayCertificate.png";
import Medical from "../../assets/LearnersUIimages/Medical.png";
import Location from "../../assets/LearnersUIimages/Location.png";
import UserDetailsModal from "../../views/Forms/UserDetailForms/UserDetailsModal";
import { drivingSchoolData } from "../../dummyData/getLearnersDetailsFormData";


const DrivingSchool = () => {

  const location = useLocation();
  const [learner, setLearner] = useState();
  const [loading, setLoading] = useState(!learner);
  // const navigate = useNavigate();
  //const [isFormFilled, setIsFormFilled] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // const checkFormFilled = () => {
  //   if (localStorage.getItem("isFormFilled") === "true") {
  //     setIsFormFilled(true);
  //     return true;
  //   } else {
  //     setIsFormFilled(false);
  //     return false;
  //   }
  // };

  // const handleJoinNowClick = () => {
  //   if (checkFormFilled()) {
  //     navigate("/joinPage");
  //   } else {
  //     setShowModal(true);
  //   }
  //   console.log("learner", learner);
  // };

  // const learnerServiceNames = learner.services.map((s) => s.id);

  // const updatedServices = drivingSchoolData
  //   .filter((item) => learnerServiceNames.includes(item.id))
  //   .map((item) => ({
  //     id: item.id,
  //     image: item.image,
  //     name: item.name,
  //   }));

  useEffect(() => {
    const fetchLearner = async () => {
      const fullPath = location.pathname;
      const learnerName = fullPath.replace("/drivingSchool/", "");

      try {
        const querySnapshot = await getDocs(collection(db, "drivingSchools"));
        const learners = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const learnerSlug = learnerName.toLowerCase().replace(/\s+/g, "-");
        const matchedLearner = learners.find(
          (l) => l.name.toLowerCase().replace(/\s+/g, "-") === learnerSlug
        );

        if (matchedLearner) {
          setLearner(matchedLearner);
        } else {
          console.error("Learner not found");
        }
      } catch (error) {
        console.error("Error fetching learner:", error);
      } finally {
        setLoading(false);
      }
    };

    if (!learner) {
      fetchLearner();
    }
  }, [learner, location.pathname]);

  const updatedServices = learner?.services?.map((service) => {
    const matched = drivingSchoolData.find((item) => item.id === service.id);
    return {
      id: service.id,
      name: service.name,
      image: matched?.image || "",
    };
  });
  // console.log("drivingSchoolData:", drivingSchoolData);
  // console.log("Updated Services:", updatedServices);

  const handleCloseModal = () => {
    setShowModal(false);
  };

 if (loading) {
   return (
     <div
       className="d-flex justify-content-center align-items-center"
       style={{ minHeight: "50vh" }}
     >
       <div className="spinner-border" role="status">
         <span className="visually-hidden">Loading...</span>
       </div>
     </div>
   );
 }
  if (!learner) return <div>Learner not found</div>;

  return (
    <div>
      {/* Hero Section */}
      <div className="driving-school-hero position-relative d-flex align-items-center justify-content-center min-vh-100">
        <div className="container position-relative z-index-1">
          <div className="hero-content p-4 p-md-5  shadow-lg">
            <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-4 gap-md-5">
              {learner.image && (
                <div className="hero-logo flex-shrink-0">
                  <img
                    src={learner.image}
                    alt={`${learner.name} logo`}
                    className="img-fluid rounded-2 border border-white border-opacity-10"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              )}
              <div className="hero-text text-center text-md-start">
                <h1 className="fw-bold mb-3 text-shadow">{learner.name}</h1>
              </div>
            </div>
            <p className="mt-3 mt-md-4 mb-0 text-center text-md-start opacity-90 hero-p">
              {learner.description}
            </p>
          </div>
        </div>
      </div>

      {/* Details Section */}
      <div id="details" className="container driving-school-details">
        <div className="row justify-content-center">
          <div className="services-page container">
            {/* Services Section */}
            <section className="services-section text-center my-5">
              <h2>Services</h2>
              <p>What you can get?</p>
              <div className="row pt-4">
                {learner.services &&
                  updatedServices.map((service, index) => (
                    <div key={index} className="col-12 col-md-4 mb-4">
                      <div className="card h-100 shadow-sm">
                        <img
                          src={service.image}
                          className="card-img-top"
                          alt={service.name}
                        />
                        <div className="card-body">
                          <h5 className="card-title">{service.name}</h5>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </section>
            {/* End of Services Section */}

            {/* Prices Section */}
            <section className="prices-section text-center my-5">
              <h2 className="mb-4">Prices</h2>
              <div className="container">
                <table className="table table-bordered table-striped shadow-sm">
                  <thead className="table-dark">
                    <tr>
                      <th className="text-start">Vehicle Type</th>
                      <th className="text-end">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {learner.prices &&
                      learner.prices.map((price, index) => (
                        <tr key={index}>
                          <td className="text-start">{price.type}</td>
                          <td className="text-end">
                            {price.price.toLocaleString()} LKR
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </section>
            {/* End of Prices Section */}
          </div>
        </div>
      </div>

      <div className="p-3" style={{ backgroundColor: "rgba(51, 51, 51, 0.1)" }}>
        <h2 className="text-center mb-4">Required Documents</h2>
        <Container className="mt-5 text-center">
          <Row className="justify-content-center">
            <Col xs={12} sm={6} md={4} className="mb-3">
              <div className="d-flex flex-column align-items-center">
                <div className="py-4 px-1 border border-dark rounded w-100 d-flex justify-content-center">
                  <img src={IdCard} className="img-fluid" alt="ID Card" />
                </div>
                <div className="mt-2">ID Card</div>
              </div>
            </Col>
            <Col xs={12} sm={6} md={4} className="mb-3">
              <div className="d-flex flex-column align-items-center">
                <div className="py-4 px-1 border border-dark rounded w-100 d-flex justify-content-center">
                  <img
                    src={BirthdayCertificate}
                    className="img-fluid"
                    alt="Birthday Certificate"
                  />
                </div>
                <div className="mt-2">Birthday Certificate</div>
              </div>
            </Col>
            <Col xs={12} sm={6} md={4} className="mb-3">
              <div className="d-flex flex-column align-items-center">
                <div className="py-4 px-1 border border-dark rounded w-100 d-flex justify-content-center">
                  <img src={Medical} className="img-fluid" alt="Medical" />
                </div>
                <div className="mt-2">Medical</div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div>
        <Container className="mt-5">
          <Row className="align-items-center">
            {/* Left Side - Image */}
            <Col xs={12} md={6} className="mb-4 mb-md-0">
              <div className="d-flex justify-content-center">
                <img
                  src={Location}
                  alt="Contact"
                  className="img-fluid rounded"
                  style={{ maxHeight: "400px", objectFit: "cover" }}
                />
              </div>
            </Col>

            {/* Right Side - Contact Info */}
            <Col xs={12} md={6}>
              <div className="p-4">
                <h3 className="mb-4 text-center text-md-start">Contact</h3>
                <p className="mb-3 text-center text-md-start">
                  <strong>Mobile:</strong>{" "}
                  <a href="tel:07105533456">{learner.hotLine}</a>
                </p>
                <p className="mb-3 text-center text-md-start">
                  <strong>Email:</strong>{" "}
                  <a href="mailto:amallearners@gmail.com">
                    {learner.branches[0].email}
                  </a>
                </p>
                <p className="mb-3 text-center text-md-start">
                  <strong>Address: </strong>
                  {learner.branches[0].branchAddress}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="pt-3">
        <div className="p-3" style={{ backgroundColor: "#333" }}>
          <h2 className="text-center mb-4 text-light">Our Branches</h2>
          <Container className="mt-5 text-center">
            {" "}
            {/* Added text-center for the container */}
            <Row className="justify-content-center">
              {learner.branches && learner.branches.length > 0 ? (
                learner.branches.map((branch, index) => (
                  <Col key={index} md={4} className="mb-3">
                    <BranchCard branch={branch} />
                  </Col>
                ))
              ) : (
                <p>No branches available.</p>
              )}
            </Row>
          </Container>
        </div>
      </div>
      {/* Add User Details Modal */}
      <UserDetailsModal showModal={showModal} handleClose={handleCloseModal} />
    </div>
  );
}

export default DrivingSchool;

